import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SparaOfferCard.module.scss';

const PUNCH_COUNT = 14;

function VerticalSeparator() {
    return (
        <div className={styles.separator}>
            <div className={styles.punchLeft} />
            <div className={styles.punchDots}>
                {Array.from({ length: PUNCH_COUNT }).map((_, i) => (
                    <div key={i} className={styles.punchDot} />
                ))}
            </div>
            <div className={styles.punchRight} />
        </div>
    );
}

function HorizontalSeparator() {
    return (
        <div className={styles.hSep}>
            <div className={styles.hPunchTop} />
            <div className={styles.hPunchDots}>
                {Array.from({ length: PUNCH_COUNT }).map((_, i) => (
                    <div key={i} className={styles.hPunchDot} />
                ))}
            </div>
            <div className={styles.hPunchBottom} />
        </div>
    );
}

const NAMED_DISCOUNT_TYPES = ['sérkjör', 'kynning', 'tilkynning', 'skráning', '2 fyrir 1'];

function OfferDiscountView({ offer }) {
    const { t } = useTranslation();
    if (!offer?.discount) return null;

    const isSpecial = !!(offer.group_ids || offer.torgid_special_company);
    const isNamedType = NAMED_DISCOUNT_TYPES.includes(
        (offer.discount || '').toLowerCase()
    );

    let discount = offer.special_discount ?? offer.discount;
    discount = discount?.charAt?.(0)?.toUpperCase?.() + discount?.slice?.(1)?.toLowerCase?.();

    // Halda sömu rótar-element-gerð (<div>) í báðum tilvikum til að styrkja
    // reconciliation þegar isSpecial togglast (t.d. meðan á markhópaval stendur).
    return (
        <div className={`${styles.discountRoot} ${isSpecial ? styles.discountRootSpecial : ''}`}>
            {isSpecial ? (
                <div className={styles.discountPill}>
                    <div className={styles.discountPillLeft}>
                        {!isNamedType && (
                            <span className={styles.discountPillLabel} translate="no">
                                {t('offer.special_offer')}
                            </span>
                        )}
                        <span className={styles.discountPillText} translate="no">{discount}</span>
                    </div>
                </div>
            ) : (
                <span className={styles.discount} translate="no">{discount}</span>
            )}
        </div>
    );
}

export function SparaVerticalCard({ offer }) {
    const { t } = useTranslation();
    const imageUrl = offer?.torgid_offer_photo_files?.[0]?.url || offer?.image || null;
    const companyName = offer?.torgid_company?.name || t('company_name');
    const companyLogo = offer?.torgid_company?.logo || null;
    const title = offer?.title || t('offer_name');

    return (
        <div className={styles.verticalCard}>
            <div className={styles.imageWrap}>
                {imageUrl ? (
                    <img src={imageUrl} className={styles.offerImage} alt="offer" />
                ) : (
                    <div className={styles.offerImagePlaceholder} />
                )}
            </div>

            <VerticalSeparator />

            <div className={styles.detailsContainer}>
                <OfferDiscountView offer={offer} />
                <p className={styles.cardTitle}>{title}</p>
                <div className={styles.companyRow}>
                    {companyLogo && (
                        <img src={companyLogo} className={styles.companyLogo} alt="" />
                    )}
                    <span className={styles.companyName}>{companyName}</span>
                </div>
            </div>
        </div>
    );
}

export function SparaHorizontalCard({ offer }) {
    const { t } = useTranslation();
    const imageUrl = offer?.torgid_offer_photo_files?.[0]?.url || offer?.image || null;
    const companyName = offer?.torgid_company?.name || t('company_name');
    const companyLogo = offer?.torgid_company?.logo || null;
    const title = offer?.title || t('offer_name');

    return (
        <div className={styles.horizontalCard}>
            <div className={styles.hImageWrap}>
                {imageUrl ? (
                    <img src={imageUrl} className={styles.hOfferImage} alt="offer" />
                ) : (
                    <div className={styles.hOfferImagePlaceholder} />
                )}
            </div>

            <HorizontalSeparator />

            <div className={styles.hDetails}>
                <div className={styles.hCompanyRow}>
                    {companyLogo && (
                        <img src={companyLogo} className={styles.hCompanyLogo} alt="" />
                    )}
                    <span className={styles.hCompanyName}>{companyName}</span>
                </div>
                <OfferDiscountView offer={offer} />
                <span className={styles.hTitle}>{title}</span>
            </div>
        </div>
    );
}
